<template>
  <div>
    <template>
      <v-tabs
        v-model="tab"
        background-color="blue-grey lighten-1"
        centered
        dark
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          Dynamic
        </v-tab>

        <v-tab href="#tab-2">
          Static
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <CoachingDashboard />
        </v-tab-item>
        <v-tab-item value="tab-2">
          <CoachingDashboardStatic />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import CoachingDashboard from "../components/CoachingDashboard";
import CoachingDashboardStatic from "../components/CoachingDashboardStatic";
import DefaultLayout from "@/layouts/DefaultLayout";

export default {
  name: "Coaching",
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  },
  components: {
    CoachingDashboard,
    CoachingDashboardStatic,
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>